module.exports = __webpack_public_path__ + "img/fwwx2.78096d83.png";